<div class="p-grid">
    <div class="p-col-12">
        <app-filter *ngIf="selectedWindow" [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)" (onChangeRange)="onChangeRange(selectedWindow, $event)">
        </app-filter>
    </div>

    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <!-- template -->
                <div *ngIf="selectedWindow == 'template1'">
                    <app-template1></app-template1>
                </div>
                <div *ngIf="selectedWindow == 'template2'">
                    <app-template2></app-template2>
                </div>
                <div *ngIf="selectedWindow == 'template3'">
                    <app-template3></app-template3>
                </div>
                <div *ngIf="selectedWindow == 'template4'">
                    <app-template4></app-template4>
                </div>
                <div *ngIf="selectedWindow == 'template5'">
                    <app-template5></app-template5>
                </div>
                <div *ngIf="selectedWindow == 'template6'">
                    <app-template6></app-template6>
                </div>
                <div *ngIf="selectedWindow == 'template7'">
                    <app-template7></app-template7>
                </div>
            </div>
        </div>
    </div>
</div>
